//#region IMPORTS
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { InstoreOrderType } from "../../models/instoreOrderType";
import { Fragment } from "react";
import { Tooltip } from "react-tooltip";
import classNames from "../../helpers/classNames";
//#endregion

//#region INTERFACE
interface Props {
  instoreOrderType: InstoreOrderType;
  editHandler: () => void;
  disabled?: boolean;
}
//#endregion

export default function InstoreOrderTypesTableRowActionEdit({
  instoreOrderType,
  editHandler,
  disabled = false,
}: Props) {
  //#region RENDER
  return (
    <Fragment>
      <button
        data-tooltip-content="Edit instore theme"
        data-tooltip-variant="warning"
        data-tooltip-place="right"
        data-tooltip-id={String(instoreOrderType.id) + "edit"}
        data-tooltip-delay-show={500}
        className="flex items-center gap-4"
        disabled={disabled}
      >
        <PencilSquareIcon
          className={classNames(
            disabled
              ? "text-gray-300 cursor-not-allowed"
              : "text-amber-500 hover:text-amber-400",
            "w-4 h-4"
          )}
          onClick={editHandler}
          type="button"
        />
      </button>
      {disabled ? null : (
        <Tooltip id={String(instoreOrderType.id) + "edit"} className="font-bold" />
      )}
    </Fragment>
  );
  //#endregion
}
